(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.dz-compare:not(.dz-compare--ready)').forEach((comparison) => {
      const radios = comparison.querySelectorAll('.dz-compare__choices input[type="radio"]');
      const update = () => {
        radios.forEach((radio) => {
          radio.closest('label').classList.toggle('is-selected', radio.checked);
          if (radio.checked) comparison.dataset.comparison = radio.value;
        });
      };
      radios.forEach((radio) => radio.addEventListener('change', update));
      update();
      comparison.classList.add('dz-compare--ready');
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
